<template>
  <svg class="icon" :class="name" aria-hidden="true" @click="$emit('click')">
    <use :xlink:href="'#' + name"></use>
    <title>{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: 'svgIcon',
  data() {
    return {}
  },
  props: ['name', 'title']
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/svgIcon.vue